import {
  DETAIL_USER_EMAIL_CHANGE_FULFILLED,
  DETAIL_USER_EMAIL_CHANGE_PENDING,
  DETAIL_USER_EMAIL_CHANGE_REJECTED,
  DETAIL_USER_FIRST_NAME_CHANGE_FULFILLED,
  DETAIL_USER_FIRST_NAME_CHANGE_PENDING,
  DETAIL_USER_FIRST_NAME_CHANGE_REJECTED,
  DETAIL_USER_GET_FULFILLED,
  DETAIL_USER_GET_PENDING,
  DETAIL_USER_GET_REJECTED,
  DETAIL_USER_GROUP_ADD_FULFILLED,
  DETAIL_USER_GROUP_ADD_PENDING,
  DETAIL_USER_GROUP_ADD_REJECTED,
  DETAIL_USER_GROUP_REMOVE_FULFILLED,
  DETAIL_USER_GROUP_REMOVE_PENDING,
  DETAIL_USER_GROUP_REMOVE_REJECTED,
  DETAIL_USER_LAST_NAME_CHANGE_FULFILLED,
  DETAIL_USER_LAST_NAME_CHANGE_PENDING,
  DETAIL_USER_LAST_NAME_CHANGE_REJECTED,
  DETAIL_USER_PASSWORD_RESET_FULFILLED,
  DETAIL_USER_PASSWORD_RESET_PENDING,
  DETAIL_USER_PASSWORD_RESET_REJECTED,
} from './actionTypes'

const initialState = {
  detailUser: {},
  error: false,
  pending: false,
  userGetDone: false,
  userGetError: false,
  userGetPending: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case DETAIL_USER_EMAIL_CHANGE_FULFILLED:
      return {
        ...state,
        detailUser: payload.data,
        error: false,
        pending: false,
      }

    case DETAIL_USER_EMAIL_CHANGE_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case DETAIL_USER_EMAIL_CHANGE_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case DETAIL_USER_FIRST_NAME_CHANGE_FULFILLED:
      return {
        ...state,
        detailUser: payload.data,
        error: false,
        pending: false,
      }

    case DETAIL_USER_FIRST_NAME_CHANGE_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case DETAIL_USER_FIRST_NAME_CHANGE_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case DETAIL_USER_GET_FULFILLED:
      return {
        ...state,
        detailUser: payload.data,
        userGetDone: false,
        userGetError: false,
        userGetPending: false,
      }

    case DETAIL_USER_GET_PENDING:
      return {
        ...state,
        userGetError: false,
        userGetPending: true,
      }

    case DETAIL_USER_GET_REJECTED:
      return {
        ...state,
        userGetError: true,
        userGetPending: false,
      }

    case DETAIL_USER_GROUP_ADD_FULFILLED:
      return {
        ...state,
        detailUser: payload.data,
        error: false,
        pending: false,
      }

    case DETAIL_USER_GROUP_ADD_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case DETAIL_USER_GROUP_ADD_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case DETAIL_USER_GROUP_REMOVE_FULFILLED:
      return {
        ...state,
        detailUser: payload.data,
        error: false,
        pending: false,
      }

    case DETAIL_USER_GROUP_REMOVE_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case DETAIL_USER_GROUP_REMOVE_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case DETAIL_USER_LAST_NAME_CHANGE_FULFILLED:
      return {
        ...state,
        detailUser: payload.data,
        error: false,
        pending: false,
      }

    case DETAIL_USER_LAST_NAME_CHANGE_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case DETAIL_USER_LAST_NAME_CHANGE_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    case DETAIL_USER_PASSWORD_RESET_FULFILLED:
      return {
        ...state,
        error: false,
        pending: false,
      }

    case DETAIL_USER_PASSWORD_RESET_PENDING:
      return {
        ...state,
        error: false,
        pending: true,
      }

    case DETAIL_USER_PASSWORD_RESET_REJECTED:
      return {
        ...state,
        error: true,
        pending: false,
      }

    default:
      return state
  }
}

export default reducer
